(function() {

	function generateNS(k, obj, context) {
		var e = k.split("."),
			f = context || window,
			g = null;
		while (g = e.shift()) {
			if (e.length) {
				f[g] === undefined && (f[g] = {});
				f = f[g]
			} else if (f[g] === undefined) {
				f[g] = obj;
			} else {
				throw "[" + k + "] : has been register";
			}
		}
	}

	function getNS(str, ctx) {
		var i = str.split("."),
			g, a = ctx || window;
		while (g = i.shift()) {
			if (a[g]) {
				a = a[g]
			} else {
				return void(0)
			}
		}
		return a;
	}

	function now() {
		return Date.now && Date.now() || new Date().getTime();
	}

	var fnTools = {
		debounce: function(func, wait, immediate) {
			var timeout, args, context, timestamp, result;

			var later = function() {
				var last = now() - timestamp;

				if (last < wait && last > 0) {
					timeout = setTimeout(later, wait - last);
				} else {
					timeout = null;
					if (!immediate) {
						result = func.apply(context, args);
						if (!timeout) context = args = null;
					}
				}
			};

			return function() {
				context = this;
				args = arguments;
				timestamp = nUtil.dateTools.getCurrentDate();
				var callNow = immediate && !timeout;
				if (!timeout) timeout = setTimeout(later, wait);
				if (callNow) {
					result = func.apply(context, args);
					context = args = null;
				}

				return result;
			};
		}
	}

	var uriTools = (function() {
		var RegEx = /\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/;

		function getDomain(str) {
			return str.match(RegEx)[3];
		}

		function getParts(str) {
			return str.match(RegEx);
		}

		function getSearchQuery(str, key) {
			return getQuerys(str.match(RegEx)[8], key);
		}

		function getHashQuery(str, key) {
			return getQuerys(str.match(RegEx)[9] ? str.match(RegEx)[9].substring(1) : false, key);
		}

		function getQuerys(str, key) {
			if (str) {
				var keyReg = new RegExp("(?:^|&)" + key + "(?:[=]?)(.*?)(?=&|$)", "i"),
					commonReg = new RegExp("(?:^|&)(.+?)(?=&|$)", "gi"),
					objects = {}, j, w;
				if (key) {
					j = keyReg.exec(str);
					return j ? j[1] : null;
				} else {
					while (w = commonReg.exec(str)) {
						var s = w[1].match(/(^[a-zA-Z0-9]+?)=(.*)/);
						if (s) {
							objects[$.trim(s[1])] = s[2]
						} else {
							objects[$.trim(w[1])] = ""
						}
					}
					return objects
				}
			} else {
				return {}
			}
		}

		return {
			getDomain: getDomain,
			getSearchQuery: getSearchQuery,
			getHashQuery: getHashQuery,
			getQuerys: getQuerys,
			getParts: getParts
		};
	})();

	var dateTools = (function() {
		var _zDate = {
			getCurrentDate: function() {
				return new Date();
			},
			/*形如：2013-12-12T12:12:12*/
			getDateByDateString: function(dateString) {
				var g = dateString.split("T"),
					i = g[0].split("-"),
					i2 = g[1].split(":"),
					j = new Date(Date.UTC(+i[0], i[1] - 1, i[2], i2[0], i2[1], i2[2]) + new Date().getTimezoneOffset() * 60 * 1000);
				return j;
			},
			timeJobs: function(timeJobsObj, option) {
				var defaultOption = {
					compareFunc: function(contextDateString) {
						if (new Date() > zUtil.zDate.getDateByDateString(contextDateString)) {
							return true;
						} else {
							return false;
						}
					}
				};
				$.extend(defaultOption, option || {});
				$.each(timeJobsObj, function(k, v) {
					var contextDateString = v.dateString;
					var contextDateCallback = v.fun;
					if (defaultOption.compareFunc(contextDateString)) {
						contextDateCallback.call(this);
					}
				});
			}
		};
		return _zDate
	})();

	var htmlTools = {
		template: function(str, data, regexp) {
			return str.replace(regexp || /\${([^{}]*)}/g, function(str, p1) {
				return (data[p1] !== undefined && data[p1] !== null && data[p1].toString()) || "";
			});
		}
	}
	var arrayTools = {
		randomArray: function(arr) {
			return arr.sort(function() {
				return Math.random() > 0.5?1:-1;
			});
		}
	};
	var calTools = {
		randomIntInRange: function(min, max) {
			var g = Math.floor(Math.random() * (max - min + 1));
			return min + g;
		}
	}
	var logTools = {
		"logWord": function(word) {
			this.log(word);
		},
		_console: function() {
			var param = Array.prototype.slice.call(arguments, 0),
				errorObj, stackInfoStr, t1, mystackInfoStr = "";
			var _style = "color:green;font-size:12px;font-family:'Consolas';border:1px dotted;line-height:25px;";
			var RegEx = /(http:\/\/.*?\.js)(:\d+)/;
			var levelName = param.shift();
			try {
				if ($.type(param[param.length - 1]) == "error") {
					errorObj = param.pop();
					stackInfoStr = errorObj.stack.toString()
					t1 = (stackInfoStr).match(RegEx);
					mystackInfoStr = t1[1] + t1[2];
				}
				if (param.length == 1 && ($.type(param[0]) == "number" || $.type(param[0]) == "string")) {
					console[levelName].call(console, "%c" + param[0] + (mystackInfoStr ? "--->" + mystackInfoStr : ""), _style);
				} else {
					console[levelName].apply(console, param.concat([mystackInfoStr]));
				}
			} catch (e) {}
		},
		"info": function() {
			var arg=Array.prototype.slice.call(arguments,0);
			this._console.apply(this, ["info"].concat(arg));
		},
		"warn": function() {
			var arg=Array.prototype.slice.call(arguments,0);
			this._console.apply(this, ["warn"].concat(arg));
		},
		"debug": function() {
			var arg=Array.prototype.slice.call(arguments,0);
			this._console.apply(this, ["debug"].concat(arg));
		},
		"log": function() {
			var arg=Array.prototype.slice.call(arguments,0);
			this._console.apply(this, ["log"].concat(arg));
		}
	}
	var statisticTools = {
		"sendDC": function(gameName, buttonName) {
			try {
				Dc_SetButtonClickData(gameName, buttonName);
				logTools.logWord("gameName:" + gameName + ",buttonName:" + buttonName);
			} catch (e) {
				logTools.logWord("请检查DC.js是否已经加载.", "color:red;font-size:14px;");
			}
		}
	}
	function initStoreAndJSON(){
		/* Copyright (c) 2010-2013 Marcus Westin */
		this.JSON||(this.JSON={}),function(){function f(e){return e<10?"0"+e:e}function quote(e){return escapable.lastIndex=0,escapable.test(e)?'"'+e.replace(escapable,function(e){var t=meta[e];return typeof t=="string"?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+e+'"'}function str(e,t){var n,r,i,s,o=gap,u,a=t[e];a&&typeof a=="object"&&typeof a.toJSON=="function"&&(a=a.toJSON(e)),typeof rep=="function"&&(a=rep.call(t,e,a));switch(typeof a){case"string":return quote(a);case"number":return isFinite(a)?String(a):"null";case"boolean":case"null":return String(a);case"object":if(!a)return"null";gap+=indent,u=[];if(Object.prototype.toString.apply(a)==="[object Array]"){s=a.length;for(n=0;n<s;n+=1)u[n]=str(n,a)||"null";return i=u.length===0?"[]":gap?"[\n"+gap+u.join(",\n"+gap)+"\n"+o+"]":"["+u.join(",")+"]",gap=o,i}if(rep&&typeof rep=="object"){s=rep.length;for(n=0;n<s;n+=1)r=rep[n],typeof r=="string"&&(i=str(r,a),i&&u.push(quote(r)+(gap?": ":":")+i))}else for(r in a)Object.hasOwnProperty.call(a,r)&&(i=str(r,a),i&&u.push(quote(r)+(gap?": ":":")+i));return i=u.length===0?"{}":gap?"{\n"+gap+u.join(",\n"+gap)+"\n"+o+"}":"{"+u.join(",")+"}",gap=o,i}}typeof Date.prototype.toJSON!="function"&&(Date.prototype.toJSON=function(e){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(e){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;typeof JSON.stringify!="function"&&(JSON.stringify=function(e,t,n){var r;gap="",indent="";if(typeof n=="number")for(r=0;r<n;r+=1)indent+=" ";else typeof n=="string"&&(indent=n);rep=t;if(!t||typeof t=="function"||typeof t=="object"&&typeof t.length=="number")return str("",{"":e});throw new Error("JSON.stringify")}),typeof JSON.parse!="function"&&(JSON.parse=function(text,reviver){function walk(e,t){var n,r,i=e[t];if(i&&typeof i=="object")for(n in i)Object.hasOwnProperty.call(i,n)&&(r=walk(i,n),r!==undefined?i[n]=r:delete i[n]);return reviver.call(e,t,i)}var j;text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(e){return"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)}));if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),typeof reviver=="function"?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})}(),function(e){function o(){try{return r in e&&e[r]}catch(t){return!1}}var t={},n=e.document,r="localStorage",i="script",s;t.disabled=!1,t.version="1.3.17",t.set=function(e,t){},t.get=function(e,t){},t.has=function(e){return t.get(e)!==undefined},t.remove=function(e){},t.clear=function(){},t.transact=function(e,n,r){r==null&&(r=n,n=null),n==null&&(n={});var i=t.get(e,n);r(i),t.set(e,i)},t.getAll=function(){},t.forEach=function(){},t.serialize=function(e){return JSON.stringify(e)},t.deserialize=function(e){if(typeof e!="string")return undefined;try{return JSON.parse(e)}catch(t){return e||undefined}};if(o())s=e[r],t.set=function(e,n){return n===undefined?t.remove(e):(s.setItem(e,t.serialize(n)),n)},t.get=function(e,n){var r=t.deserialize(s.getItem(e));return r===undefined?n:r},t.remove=function(e){s.removeItem(e)},t.clear=function(){s.clear()},t.getAll=function(){var e={};return t.forEach(function(t,n){e[t]=n}),e},t.forEach=function(e){for(var n=0;n<s.length;n++){var r=s.key(n);e(r,t.get(r))}};else if(n.documentElement.addBehavior){var u,a;try{a=new ActiveXObject("htmlfile"),a.open(),a.write("<"+i+">document.w=window</"+i+'><iframe src="/favicon.ico"></iframe>'),a.close(),u=a.w.frames[0].document,s=u.createElement("div")}catch(f){s=n.createElement("div"),u=n.body}var l=function(e){return function(){var n=Array.prototype.slice.call(arguments,0);n.unshift(s),u.appendChild(s),s.addBehavior("#default#userData"),s.load(r);var i=e.apply(t,n);return u.removeChild(s),i}},c=new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]","g");function h(e){return e.replace(/^d/,"___$&").replace(c,"___")}t.set=l(function(e,n,i){return n=h(n),i===undefined?t.remove(n):(e.setAttribute(n,t.serialize(i)),e.save(r),i)}),t.get=l(function(e,n,r){n=h(n);var i=t.deserialize(e.getAttribute(n));return i===undefined?r:i}),t.remove=l(function(e,t){t=h(t),e.removeAttribute(t),e.save(r)}),t.clear=l(function(e){var t=e.XMLDocument.documentElement.attributes;e.load(r);for(var n=0,i;i=t[n];n++)e.removeAttribute(i.name);e.save(r)}),t.getAll=function(e){var n={};return t.forEach(function(e,t){n[e]=t}),n},t.forEach=l(function(e,n){var r=e.XMLDocument.documentElement.attributes;for(var i=0,s;s=r[i];++i)n(s.name,t.deserialize(e.getAttribute(s.name)))})}try{var p="__storejs__";t.set(p,p),t.get(p)!=p&&(t.disabled=!0),t.remove(p)}catch(f){t.disabled=!0}t.enabled=!t.disabled,typeof module!="undefined"&&module.exports&&this.module!==module?module.exports=t:typeof define=="function"&&define.amd?define(t):e.store=t}(Function("return this")())
	}
	function initCookieAPI(){
		/*! js-cookie v2.0.3 | MIT Copyright 2006, 2015 Klaus Hartl & Fagner Brack*/
		!function(a){if("function"==typeof define&&define.amd)define(a);else if("object"==typeof exports)module.exports=a();else{var b=window.Cookies,c=window.Cookies=a(window.jQuery);c.noConflict=function(){return window.Cookies=b,c}}}(function(){function a(){for(var a=0,b={};a<arguments.length;a++){var c=arguments[a];for(var d in c)b[d]=c[d]}return b}function b(c){function d(b,e,f){var g;if(arguments.length>1){if(f=a({path:"/"},d.defaults,f),"number"==typeof f.expires){var h=new Date;h.setMilliseconds(h.getMilliseconds()+864e5*f.expires),f.expires=h}try{g=JSON.stringify(e),/^[\{\[]/.test(g)&&(e=g)}catch(i){}return e=encodeURIComponent(String(e)),e=e.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),b=encodeURIComponent(String(b)),b=b.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),b=b.replace(/[\(\)]/g,escape),document.cookie=[b,"=",e,f.expires&&"; expires="+f.expires.toUTCString(),f.path&&"; path="+f.path,f.domain&&"; domain="+f.domain,f.secure?"; secure":""].join("")}b||(g={});for(var j=document.cookie?document.cookie.split("; "):[],k=/(%[0-9A-Z]{2})+/g,l=0;l<j.length;l++){var m=j[l].split("="),n=m[0].replace(k,decodeURIComponent),o=m.slice(1).join("=");'"'===o.charAt(0)&&(o=o.slice(1,-1));try{if(o=c&&c(o,n)||o.replace(k,decodeURIComponent),this.json)try{o=JSON.parse(o)}catch(i){}if(b===n){g=o;break}b||(g[n]=o)}catch(i){}}return g}return d.get=d.set=d,d.getJSON=function(){return d.apply({json:!0},[].slice.call(arguments))},d.defaults={},d.remove=function(b,c){d(b,"",a(c,{expires:-1}))},d.withConverter=b,d}return b()});
		Cookies.json = true;
	}
	initStoreAndJSON.call(window);
	initCookieAPI.call(window);
	var storageTools={
		store:$.extend({},window.store),/*使用方式见:https://github.com/marcuswestin/store.js*/
		cookies:Cookies.noConflict()/*使用方式见:https://github.com/js-cookie/js-cookie*/
	}
	var w = {
		logTools: logTools,
		generateNS: generateNS,
		getNS: getNS,
		fnTools: fnTools,
		uriTools: uriTools,
		dateTools: dateTools,
		htmlTools: htmlTools,
		arrrayTools: arrayTools,
		storageTools:storageTools,
		calTools: calTools,
		statisticTools: statisticTools
	};
	window.modulizer && modulizer.define("Util", function() {
		return w
	}) || (window.nUtil =w );

})(window.jQuery||window.Zepto);
